module.exports = __webpack_public_path__ + "fonts/KFOkCnqEu92Fr1MmgVxLIzIFKw.36fe9ac3.woff2";